import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Message } from 'primeng/message'
import { TranslateModule } from '@ngx-translate/core'
import { ButtonModule } from 'primeng/button'
import { RouterModule } from '@angular/router'
import { UtilsService } from '../../../services/utils/utils.service'

@Component({
  imports: [CommonModule, Message, TranslateModule, ButtonModule, RouterModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundPageComponent {
  constructor(private utilsService: UtilsService) {}

  ngOnInit() {
    this.utilsService.initPageTitle('NOT_FOUND_PAGE.TITLE')
  }
}
